<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;" (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">

    <!-- Email search -->
    <div class="search-bar">
      <input type="email" class="form-control"
             placeholder="emailAddress@us.pwc.com"
             [(ngModel)]="email_id"
             (keyup)="onEmailKeyup($event)">
      <button class="btn btn-success" type="button" (click)="findUser()">Find User</button>
    </div>

    <hr />

    <!-- Loading spinner -->
    @if (loading) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
}

    <!-- User details area -->
    @if (!loading) {
<div class="gt-user-details">

      <!-- Already in system -->
      @if (display === 'update') {
<div class="user-row" style="text-align: left;">
        <div class="profile-col">
          @if (avatarUrl) {
<img class="avatar-img" [src]="avatarUrl"
               (error)="avatarError = true" [hidden]="avatarError">
}
          @if (!avatarUrl || avatarError) {
<div class="avatar-placeholder">
            <i class="fa fa-user"></i>
          </div>
}
        </div>
        <div class="info-col">
          <h4>{{ user.first_name }} {{ user.last_name }} ({{ user.sso_id }})</h4>
          <p>is already in the system</p>
          <div class="action-buttons">
            <button class="btn btn-info btn-sm" type="button"
                    (click)="editUser(user.sso_id, user.client_key)">Edit User</button>
            <button class="btn btn-warning btn-sm" type="button"
                    (click)="cancel()">Close</button>
          </div>
        </div>
      </div>
}

      @if (display === 'create') {
<form class="create-user-form" (ngSubmit)="addUser()">
        <div class="form-grid">
          <label>
            <span class="field-label">Email <span class="required">*</span></span>
            <input class="form-control" type="email" name="formEmail" maxlength="200" required
                   [ngModel]="formEmail()" (ngModelChange)="formEmail.set($event)">
          </label>
          <label>
            <span class="field-label">First Name <span class="required">*</span></span>
            <input class="form-control" name="first_name" maxlength="50" required
                   [ngModel]="first_name()" (ngModelChange)="first_name.set($event)">
          </label>
          <label>
            <span class="field-label">Last Name <span class="required">*</span></span>
            <input class="form-control" name="last_name" maxlength="50" required
                   [ngModel]="last_name()" (ngModelChange)="last_name.set($event)">
          </label>
          <label>
            <span class="field-label">User Type <span class="required">*</span></span>
            <select class="form-control" name="user_type" required
                    [(ngModel)]="user_type" [compareWith]="compareByValue">
              @for (type of user_types; track type.value) {
<option [ngValue]="type">{{ type.label }}</option>
}
            </select>
          </label>
          <label class="active-field">
            Active
            <input type="checkbox" name="active" [ngModel]="active == 1" (ngModelChange)="active = $event ? 1 : 0">
          </label>
        </div>

        @if (availableOptionalFields().length) {
<div class="optional-builder">
          <label>
            Additional detail
            <select class="form-control" name="optionalField"
                    [ngModel]="selectedOptionalKey()" (ngModelChange)="selectedOptionalKey.set($event)">
              <option value="">Select a field</option>
              @for (field of availableOptionalFields(); track field.key) {
<option [value]="field.key">{{ field.label }}</option>
}
            </select>
          </label>
          <label>
            Value
            <input class="form-control" name="optionalDraft"
                   [ngModel]="optionalDraft()" (ngModelChange)="optionalDraft.set($event)"
                   [attr.maxlength]="selectedOptionalField()?.maxLength || null">
          </label>
          <button class="btn btn-success btn-sm add-optional-btn" type="button" (click)="addOptionalField()"
                  [disabled]="!selectedOptionalField() || !optionalDraft().trim()">Add</button>
        </div>
}

        @for (field of optionalAttributes(); track field.key) {
<div class="optional-row">
          <span class="optional-label">{{ field.label }}</span>
          <span class="optional-value">{{ field.value }}</span>
          <button class="btn btn-warning btn-sm" type="button" (click)="removeOptionalField(field.key)">Remove</button>
        </div>
}
      </form>
}

      @if (display === 'error') {
<div class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i> The user search could not be completed. Please try again.
      </div>
}
    </div>
}

    @if (display === 'create') {
<div class="action-buttons modal-actions">
      <button class="btn btn-info btn-sm" type="button" (click)="addUser()" [disabled]="!canSave || updating">
        @if (updating) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Add User
      </button>
      <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
    </div>
}

  </div>

  <div class="modal-footer" [hidden]="minimise"></div>
</div>
